const $$ = (selector) => document.querySelector(selector);

export const Password = ({ eyeIconSelector, passInputSelector }) => {
  let typeState;

  const passTypeBehaviorUI = {
    password: {
      input: 'text',
      classAdd: 'fa-eye-slash',
      classRemove: 'fa-eye',
    },
    text: {
      input: 'password',
      classAdd: 'fa-eye',
      classRemove: 'fa-eye-slash',
    },
  };

  const handleChangeAttrPass = () => {
    const passwordInput = $$(passInputSelector);
    if (!passwordInput) return;
    const type = passwordInput.getAttribute('type');
    const newType = passTypeBehaviorUI[type].input;
    passwordInput.setAttribute('type', newType);
    return type;
  };

  const handleChangeIconPassUI = (e) => {
    const { target: passwordIcon } = e;
    if (!passwordIcon) return;
    const newClassAdd = passTypeBehaviorUI[typeState].classAdd;
    const newClassRemove = passTypeBehaviorUI[typeState].classRemove;

    passwordIcon.classList.add(newClassAdd);
    passwordIcon.classList.remove(newClassRemove);
  };

  const handleChangePasswordUI = (e) => {
    typeState = handleChangeAttrPass();
    if (!typeState) return;
    handleChangeIconPassUI(e);
  };

  const init = () => {
    const eyeIcon = $$(eyeIconSelector);
    if (!eyeIcon) return;
    eyeIcon.addEventListener('click', (e) =>
      handleChangePasswordUI(e, passInputSelector),
    );
  };

  init();
};
